var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNorway(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 33c0 6.075-3.373 11-10 11H10C3.373 44 0 39.075 0 33V11C0 4.925 3.373 0 10 0h44c6.627 0 10 4.925 10 11v22z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0h11v44H18V0z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17h64v10H0V17z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0h7v44h-7V0z",
    fill: "#2B3990"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19h64v6H0v-6z",
    fill: "#2B3990"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default ForwardRef;